import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (
  dateString: string,
  format = "MMM DD, YYYY hh:mm A"
) => {
  if (!dateString) return "";
  return dayjs.utc(dateString).local().format(format);
};